export default class BingMaps {
    constructor() {
        this.infoWindowTemplate = '<div class="infoBox"><div class="close">X</div>{info}</div>';
    }
    load(key, element, lat, lng, zoom) {
        this.element = element;
        key = key != "" ? key : "AnXe8-OT_ucdhFhp5eBj7K_qtOtUBPyvGYFQlKCOW8QHnm0aztusYx1FyQ-LFU7N";
        return new Promise((resolve, reject) => {
            window["bingMapsCallback"] = () => {
                resolve(this);
                this.init(element, lat, lng, zoom);
            };
            let script = document.createElement("script");
            script.async = true;
            script.defer = true;
            script.setAttribute("src", "https://www.bing.com/api/maps/mapcontrol?callback=bingMapsCallback&key=" + key);
            script.addEventListener("load", () => {
                //resolve(this);
                //this.init(element, lat, lng, zoom);
            });
            window.document.head.appendChild(script);
        });
    }
    init(element, lat, lng, zoom) {
        let options = {
            showDashboard: true,
            disableBirdseye: true,
            showLocateMeButton: false,
            showMapTypeSelector: false,
            enableInertia: true,
            showLogo: false,
            enableClickableLogo: false,
            liteMode: false,
            disableStreetside: true,
            disableStreetsideAutoCoverage: true,
            enableHighDpi: true,
        };
        this.map = new Microsoft.Maps.Map(element, options);
        this.map.setView({
            mapTypeId: Microsoft.Maps.MapTypeId.road,
            center: new Microsoft.Maps.Location(lat, lng),
            zoom: zoom
        });
        this.markerLayer = new Microsoft.Maps.Layer("MarkerLayer");
        this.map.layers.insert(this.markerLayer);
        this.markers = [];
    }
    render() {
    }
    addMarker(lat, lng, label, info, icon, iconX, iconY) {
        let options = {};
        if (icon != null)
            options.icon = icon;
        if (iconX != null && iconY != null)
            options.anchor = new Microsoft.Maps.Point(iconX, iconY);
        let marker = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(lat, lng), options);
        this.markerLayer.add(marker);
        this.markers.push(marker);
        if (info != null) {
            let content = info;
            Microsoft.Maps.Events.addHandler(marker, "click", (e) => {
                this.addInfoWindow(marker.getLocation(), content);
            });
        }
    }
    removeMarker(index) {
        if (index < 0 || index > this.markers.length - 1)
            return;
        let marker = this.markers[index];
        this.markerLayer.remove(marker);
        this.markers.splice(index, 1);
    }
    addInfoWindow(location, info) {
        if (this.infoWindow !== undefined) {
            this.infoWindow.setMap(null);
            this.infoWindow = undefined;
        }
        this.infoWindow = new Microsoft.Maps.Infobox(location, {
            htmlContent: this.infoWindowTemplate.replace('{info}', info)
        });
        this.infoWindow.setMap(this.map);
        this.infoWindow.setOptions({
            closeDelayTime: 0
        });
        setTimeout(() => {
            let box = window.document.querySelector(".infoBox .close");
            box.addEventListener("click", () => {
                this.closeInfoWindow();
            });
        }, 200);
    }
    closeInfoWindow() {
        this.infoWindow.setOptions({ visible: false });
    }
}
